import {getElement} from "@stencil/core";
import {Md5} from "ts-md5";

/**
 * decorator to extract font-faces to implement it in the root document
 * otherwise fonts not working in the shadow-dom
 */
export const FontFaces = () => {
  return function (target: any, _property: string) {
    let regExp = /\@font-face(\s*?.*?){(\s*?.*?)*?\}(?!\/)/g;

    // save a reference to the original connectedCallback
    let original = target.connectedCallback || function(){};

    // a utility function to generate instances of a class
    function _callback(_instance: any, args: any) {
      let c : any = function () {
        return _instance.apply(this, args);
      }

      return new c();
    }

    // the new connectedCallback behaviour
    let _connectedCallback : any = async function (...args: any[]) {
      let matches = regExp.exec(this.constructor.style);
      if(matches) {
        let styles = '';
        matches.forEach((fontFace) => {
          if (fontFace.indexOf('@font-face') !== -1) {
            styles += fontFace;
          }
        });

        // @ts-ignore
        let doc: Document = getElement(this).ownerDocument,
            id: string = 'font-face-' + new Md5().appendStr(styles).end();

        // @ts-ignore adjust asset root, try to catch assets root from meta field assetRoot
        let assetRootMeta: HTMLElement = doc.querySelector('meta[name="assetRoot"]'),
            assetRoot = "";
        if(assetRootMeta) {
          // @ts-ignore
          assetRoot = assetRootMeta.getAttribute("content");

          if (styles.indexOf("asset/") != -1 && styles.indexOf(assetRoot) == -1) {
            styles = styles.replace(/asset\//g, assetRoot);
          } else if (styles.indexOf("asset/") == -1 && styles.indexOf(assetRoot) == -1) {
            //styles = styles.replace(/url\("/g, 'url("' + assetRoot); //7.576.446  404  (7.784 %) 2021-12-13
            styles = styles.replace(/(url\(\"\.\.\/)|(url\(\"\.\/)/g, 'url("' + assetRoot);
          }
          styles = styles.replace('//', '/');
        }

        // @ts-ignore
        if (doc.getElementById(id) !== null) {
          return;
        }

        // @ts-ignore
        const fontFaceSheet: HTMLElement = doc.createElement('style');
        // @ts-ignore
        fontFaceSheet.id = id;
        // @ts-ignore
        fontFaceSheet.appendChild(doc.createTextNode(styles));

        // @ts-ignore
        doc.querySelector('head').appendChild(fontFaceSheet);
      }

      return _callback(original, args);
    };

    target.connectedCallback = _connectedCallback;

    // return class with new connectedCallback (will override original)
    return target;
  };
};
